module.exports = __webpack_public_path__ + "img/web.1254ec70.svg";